import React from 'react';
import PropTypes from 'prop-types';
import { useFloatingTooltip } from 'hooks/useFloatingTooltip';

import './style.scss';

const StatusIndicator = ({ children, connected }) => {
  const {
    showTooltip: showConnectedStatusTooltip,
    hideTooltip: hideConnectedStatusTooltip,
    updateTooltip: updateConnectedStatusTooltip,
    tooltipElement: statusConnectedTooltipElement,
  } = useFloatingTooltip('Connected Integration');

  const {
    showTooltip: showDisconnectedStatusTooltip,
    hideTooltip: hideDisconnectedStatusTooltip,
    updateTooltip: updateDisconnectedStatusTooltip,
    tooltipElement: statusDisconnectedTooltipElement,
  } = useFloatingTooltip('Integration Disconnected');

  return (
    <div className="status">
      <div
        className={connected && 'org-member-active'}
        onMouseEnter={e => {
          if (connected) {
            showConnectedStatusTooltip();
            updateConnectedStatusTooltip(e);
          } else {
            showDisconnectedStatusTooltip();
            updateDisconnectedStatusTooltip(e);
          }
        }}
        onMouseMove={e => {
          if (connected) {
            updateConnectedStatusTooltip(e);
          } else {
            updateDisconnectedStatusTooltip(e);
          }
        }}
        onMouseLeave={(e) => connected ? hideConnectedStatusTooltip(e) : hideDisconnectedStatusTooltip(e)}
      >
        {connected ? statusConnectedTooltipElement : statusDisconnectedTooltipElement}
        {children}
      </div>
    </div>
  );
};

StatusIndicator.propTypes = {
  children: PropTypes.node,
};

StatusIndicator.defaultProps = {};

export default StatusIndicator;

